import { DateTime } from "luxon";
import { z } from "zod/v4-mini";

import { FileModel, fileSchema } from "@/models/FileModel.ts";
import { cz } from "@/utils/zodUtils.ts";

type RawPrescriptionInfo = {
  birthDate?: string;
  file?: FileModel;
};

export type GeneratePrescriptionInfo = {
  birthDate: string;
};

export type UploadPrescriptionFile = {
  file: FileModel;
};

export type PrescriptionInfo = GeneratePrescriptionInfo | UploadPrescriptionFile;

const requiredBirthDateOrFile = (data: RawPrescriptionInfo) => {
  if ("file" in data && data.file?.name) {
    return true;
  }
  return !!data.birthDate;
};

export const prescriptionInfoSchema = z
  .object({
    birthDate: z.optional(
      z.iso.date("form.date.invalid").check(cz.validation.dateBefore(DateTime.now(), "form.date.future")),
    ),
    file: z.optional(fileSchema),
  })
  .check(
    z.refine(requiredBirthDateOrFile, {
      path: ["birthDate"],
      error: "form.required",
    }),
  );
